// extracted by mini-css-extract-plugin
module.exports = {"button":"button__gSrcr","buttonGroup":"buttonGroup__SaLt6","p":"p__uJhIj","switch":"switch__z8nov"};